/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import { AI_TOOL_COUNT } from "./constants";

export interface ComparisonRow {
  feature: string;
  mobile: string | boolean;
  starter: string | boolean;
  professional: string | boolean;
  business: string | boolean;
}

export interface ComparisonCategory {
  name: string;
  rows: ComparisonRow[];
}

export const pricingComparison: ComparisonCategory[] = [
  {
    name: "Platform Access",
    rows: [
      {
        feature: "Mobile app",
        mobile: true,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Web platform",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Office seats",
        mobile: "—",
        starter: "1",
        professional: "Up to 5",
        business: "Up to 15",
      },
      {
        feature: "Field seats (crew / laborers)",
        mobile: "—",
        starter: "—",
        professional: "Up to 10",
        business: "Up to 30",
      },
    ],
  },
  {
    name: "Estimating & Pricing",
    rows: [
      {
        feature: "AI Quick Estimates / month",
        mobile: "25",
        starter: "50",
        professional: "250",
        business: "Unlimited",
      },
      {
        feature: "AI-scaffolded estimates",
        mobile: true,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Manual line items + variance factors",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Pre-loaded cost database (8 trades)",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Blueprint takeoffs",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Work packages (assemblies)",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Labor rate + burden pricing",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
    ],
  },
  {
    name: "Proposals & Clients",
    rows: [
      {
        feature: "Proposal templates",
        mobile: "Basic",
        starter: "3",
        professional: "Unlimited",
        business: "Unlimited + branded",
      },
      {
        feature: "E-sign",
        mobile: false,
        starter: false,
        professional: false,
        business: true,
      },
      {
        feature: "Client portal",
        mobile: true,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "CRM & contact management",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
    ],
  },
  {
    name: "Projects & Cost Lifecycle",
    rows: [
      {
        feature: "Project tracking",
        mobile: "View + photos",
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Budget detail view",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Change orders",
        mobile: false,
        starter: "Submit + approve",
        professional: "Full lifecycle",
        business: "Full + multi-division",
      },
      {
        feature: "POs · bids · subcontractors",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Time entries",
        mobile: "Own only",
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Invoicing & payments",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Progress billing",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Schedule (Gantt)",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Offline mode",
        mobile: false,
        starter: false,
        professional: true,
        business: "Priority support",
      },
    ],
  },
  {
    name: "AI Assistant (Hank)",
    rows: [
      {
        feature: "Monthly AI budget",
        mobile: "$9",
        starter: "$32",
        professional: "$60",
        business: "$120",
      },
      {
        feature: "AI tools available",
        mobile: "Quick Estimate",
        starter: "Basic set",
        professional: `${AI_TOOL_COUNT}`,
        business: `${AI_TOOL_COUNT} + priority queue`,
      },
      {
        feature: "AI cost matching & analysis",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "AI blueprint measurement assist",
        mobile: false,
        starter: false,
        professional: false,
        business: true,
      },
    ],
  },
  {
    name: "Administration",
    rows: [
      {
        feature: "Role-based access",
        mobile: false,
        starter: false,
        professional: true,
        business: true,
      },
      {
        feature: "Division management",
        mobile: false,
        starter: false,
        professional: false,
        business: true,
      },
      {
        feature: "API access",
        mobile: false,
        starter: false,
        professional: false,
        business: true,
      },
      {
        feature: "QuickBooks import",
        mobile: false,
        starter: true,
        professional: true,
        business: true,
      },
      {
        feature: "Storage",
        mobile: "5 GB",
        starter: "10 GB",
        professional: "50 GB",
        business: "100 GB",
      },
      {
        feature: "Support",
        mobile: "Email",
        starter: "Email (24hr)",
        professional: "Priority email",
        business: "Priority",
      },
    ],
  },
];
